import { CompanyStatus } from '@/gen/inventory/v1/company_status_pb'

import { BadgeProps } from '@/components/lemmala-design-system/badge/badge'

export const getStatusVariant = (status: CompanyStatus): BadgeProps['variant'] => {
  switch (status) {
    case CompanyStatus.APPROVED:
      return 'success'
    case CompanyStatus.IN_ASSESSMENT:
      return 'neutral'
    case CompanyStatus.ASSESSMENT_REQUIRED:
      return 'attention'
    case CompanyStatus.REJECTED:
      return 'danger'
    default:
      return 'neutral'
  }
}
